import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Flex from "components/common/Flex";
import SubtleBadge from "components/common/SubtleBadge";
import { useAppContext } from "Main";

const NavbarVerticalMenuItem = ({ route, hover, collapsed }) => {
  // console.log("hover", hover);
  // console.log("collpased", collapsed);

  const {
    config: {
      navbarPosition,
      navbarStyle,
      isNavbarVerticalCollapsed,
      showBurgerMenu,
      varticalNavbarHover,
    },
    setConfig,
  } = useAppContext();

  return (
    <>
      {isNavbarVerticalCollapsed && !varticalNavbarHover ? (
        <Flex
          direction={"column"}
          style={
            {
              // paddingLeft: "16px",
              // display: "flex",
              // alignItems: "center",
              // flexDirection: "column",
            }
          }
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "60px",
              margin: "2px",
            }}
          >
            <div style={{ fontSize: "19px", marginBottom: 4 }}>
              {route.icon}
            </div>
            <div
              style={{
                fontSize: "10px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "60px",
              }}
            >
              {route.name}
            </div>
          </div>
        </Flex>
      ) : (
        <Flex
          alignItems="center"
          // justifyContent={"start"}
          // direction="row"
          style={{
            paddingLeft: "10px",
            textAlign: "center",
          }}
        >
          {route.icon && (
            <span className="nav-link-icon px-1">
              {/* <FontAwesomeIcon icon={route.icon} /> */}
              {route.icon}
            </span>
          )}

          <span className="nav-link-text ps-1">{route.name}</span>
          {route.badge && (
            <SubtleBadge pill bg={route.badge.type} className="ms-2">
              {route.badge.text}
            </SubtleBadge>
          )}
        </Flex>
      )}
    </>
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string,
  to: PropTypes.string,
  // icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired,
  hover: PropTypes.bool,
  collapsed: PropTypes.bool,
};

export default React.memo(NavbarVerticalMenuItem);
